import React, { useEffect } from "react";
import profie from '../imgs/easy-peasy_bHssCVPDEP.png'
import './main.css';

function Main() {
    useEffect(() => {
        const observerOptions = {
          rootMargin: "0px",
          threshold: 0.5, // 화면의 50%가 보일 때 트리거
        };
    
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add("show"); // 화면에 보일 때 show 클래스를 추가
            }
          });
        }, observerOptions);
    
        // 각 intro 요소를 관찰
        const elementsToObserve = document.querySelectorAll(".intro2, .intro3, .intro4, .intro4-line, .tenacity, .responsibility, .harmony");
        elementsToObserve.forEach(el => observer.observe(el));
      }, []);

    return (
        <div className="main">
            <div className="intro1">
                안녕하세요.
            </div>
            <div className="intro2">
                <div className="intro2-img"><img src={profie} /></div>
                <div className="intro2-txt">
                    <div className="intro2-txt2">찾아주셔서 감사합니다.</div>
                    <div className="intro3">
                        백엔드 개발자, 김민상 입니다.
                    </div>
                </div>
            </div>
            
            <div className="intro4">
                <div className="about-me">
                    저는 이런 사람이에요
                </div>
                <div className="intro4-line">
                    <div className="line"></div>
                </div>
                <div className="about-me-detail">
                    <div className="tenacity">
                        <span className="tenacity-text">끈기</span>
                        <div className="tenacity-detail">
                        끈기를 가지고 <br/>
                        끊임없이 고민하고 <br/>
                        개발하는 사람 <br/>
                        </div>
                    </div>
                    <div className="responsibility">
                        <span className="responsibility-text">책임감</span>
                        <div className="responsibility-detail">
                        책임감을 가지고 <br/>
                        맡은 역할을 착실히 <br/>
                        성공적으로 마무리하는 사람 <br/>
                        </div>
                    </div>
                    <div className="harmony">
                        <span className="harmony-text">조화</span>
                        <div className="harmony-detail">
                        팀의 화합을 위해 <br/>
                        유연한 사고를 가지고 <br/>
                        조화를 이루는 사람 <br/>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default Main;